import { Observable } from 'rxjs';
import { TpvDispersion } from '@app/domain/models/tpv/dispersion.model';
import { TpvListQuery, TpvPage } from '@app/domain/models/tpv/tpv-page.model';

/**
 * Filtros del listado de dispersiones.
 *
 * Extiende los comunes con los que ofrece SU drawer y que el micro soporta
 * (`SearchDispersionInput`). Antes solo tenía los comunes, así que la búsqueda
 * con filtros no cabía en la fachada y el servicio terminaba pegándole al
 * gateway GraphQL legacy.
 */
export interface DispersionListQuery extends TpvListQuery {
  minAmount?: number;
  maxAmount?: number;
  status?: string;
  /** El micro lo define en SINGULAR; el drawer ofrece varios y manda el único. */
  processor?: string;
}

/**
 * Port de lectura de dispersiones.
 * `externalIdMerchant` (UUID) es OPCIONAL: si se envía, se filtra a ese comercio
 * (`id_merchant`); si se OMITE, el backend devuelve todas las dispersiones de los
 * comercios a los que el usuario tiene acceso (scope automático, sin que el front
 * mande la lista). Paridad con `GET /api/v1/tpv/transactions/`.
 */
export abstract class DispersionRepository {
  abstract getDispersions(
    externalIdMerchant?: string,
    query?: DispersionListQuery,
  ): Observable<TpvPage<TpvDispersion>>;

  /** Detalle de UNA dispersión por su id (`GET /dispersions/<id_dispersion>/`). */
  abstract getDispersionById(
    idDispersion: string | number,
  ): Observable<TpvDispersion | null>;
}
